export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fcb325e67d05ac4f786944c5f1f003b1cebdb38f8&name=fetchTypeahead!'